<div class="modal-header">
    <h4 class="modal-title" id="modal-title">
        {{ 'customManufacturerCampaign.instructions.title' | cxTranslate }}
    </h4>
    <button type="button" class="close" aria-describedby="modal-title" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="container-fluid">
        <div class="instructionsParagraph"
            [innerHTML]="'customManufacturerCampaign.instructions.informationParagraph' | cxTranslate">
        </div>
        <div class="statusParagraph">
            <div >
                <img src="assets/images/manufacturer-campaign-status/open.png"/>
                <p>{{ 'customManufacturerCampaign.instructions.status1' | cxTranslate }}
            </div>
            <div>
                <img src="assets/images/manufacturer-campaign-status/inprogress.png"/>
                <p>{{ 'customManufacturerCampaign.instructions.status2' | cxTranslate }}
            </div>
            <div>
                <img src="assets/images/manufacturer-campaign-status/rejected.png"/>
                <p>{{ 'customManufacturerCampaign.instructions.status3' | cxTranslate }}
            </div>
            <div>
                <img src="assets/images/manufacturer-campaign-status/paidout.png"/>
                <p>{{ 'customManufacturerCampaign.instructions.status4' | cxTranslate }}
            </div>
        </div>
        <div class="importParagraph">
            <p>{{'customManufacturerCampaign.instructions.importCsvParagraphTitle' | cxTranslate }}</p><br>
            <p>{{ 'customManufacturerCampaign.instructions.importCsvParagraph' | cxTranslate }}
            <a href="assets/files/Muster_Abverkaufsmeldung.csv">
                    {{ 'customManufacturerCampaign.instructions.downloadLink' | cxTranslate }}</a>
            <p [innerHTML]="'customManufacturerCampaign.instructions.importCsvParagraphContinued' | cxTranslate"></p>
            <br>
            <p [innerHTML]="'customManufacturerCampaign.instructions.importCsvParagraphContinued2' | cxTranslate"></p>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('cancel click')">
        {{ 'customManufacturerCampaign.instructions.close' | cxTranslate }}
    </button>
</div>